import React from 'react';
import AppLayout from '../../layout/app.layout';
import ContentScheduleInfo from '../../components/ruleset/content-schedule-info.component';

const ChannelContentSchedulingView = () => {
  const pageTitle = 'Schedule Videos / Rule Based Scheduling';

  return (
    <AppLayout pageTitle={pageTitle}>
      <ContentScheduleInfo />
    </AppLayout>
  );
};

export default ChannelContentSchedulingView;
